import { admin2 } from '@/api/instance'

export const CreatePospalConfig = async ({
  shopId,
  config,
  enabled,
}) => {
  return await admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/posPal`,
    data: {
      enabled,
      config,
    },
  })
}

export const UpdatePospalConfig = async ({
  shopId,
  config,
  enabled,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopCustomModule/pospal`,
    data: {
      enabled,
      config,
    },
  })
}

/**
 * 更新門市pospal串接設定
 * @param {Object} params - 參數對象
 * @param {string} params.shopId - 商店 ID
 * @param {string} params.branchId - 門市 ID
 * @param {string|null} params.appId - PosPal appId
 * @param {string|null} params.appKey - PosPal appKey
 * @returns {Promise} API 響應
 */
export const UpsertBranchPosPalConfig = async ({
  shopId,
  branchId,
  appId,
  appKey,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopCustomModule/posPal/upsertBranchPosPalConfig`,
    data: {
      branchId,
      appId,
      appKey,
    },
  })
}

export const UpsertPospalShopId = async ({
  shopId,
  branchId,
  pospalAreaId,
  pospalHost,
  pospalAppId,
  pospalAppKey,
}) => {
  return admin2({
    method: 'PUT',
    url: `/${shopId}/shopCustomModule/upsertPospalShopId`,
    data: {
      branchId,
      pospalAreaId,
      pospalHost,
      pospalAppId,
      pospalAppKey,
    },
  })
}

export const FindPospalWallet = async ({
  shopId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/posPalMemberWallet`,
    data: {
      memberId,
    },
  })
}

export const GetPospalClientConfig = async ({
  shopId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/posPalClientConfig`,
    data: {},
  })
}

export const SyncPospalMember = async ({
  shopId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/syncPosPalClientMember`,
    data: {
      memberId,
    },
  })
}

export const CheckPospalMemberSync = ({
  shopId,
  memberId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/retrievePosPalClientMember`,
    data: {
      memberId,
    },
  })
}

export const SyncPospalMemberLevel = async ({
  shopId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/syncPosPalClientMemberLevel`,
  })
}

export const SyncPospalCoupon = async ({
  shopId,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/syncPosPalCoupon`,
    data: {},
  })
}

/**
 * admin.couponPospal.find
 * 取得瑞乘優惠券列表
 * @param {Object} params
 * @param {string} params.shopId
 * @param {number} params.start
 * @param {number} params.limit
 * @param {string} [params.name]
 * @param {string} [params.pospalEcouponId]
 */
export const GetPospalCoupon = async ({
  shopId,
  start,
  limit,
  name,
  pospalEcouponId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponPospal`,
    params: {
      start,
      limit,
      name,
      pospalEcouponId,
    },
  })
}

/**
 * admin.couponPospal.count
 * 取得瑞乘優惠券列表數量
 * @param {Object} params
 * @param {string} params.shopId
 * @param {string} [params.name]
 * @param {string} [params.pospalEcouponId]
 */
export const GetPospalCouponCount = async ({
  shopId,
  name,
  pospalEcouponId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponPospal/count`,
    params: {
      name,
      pospalEcouponId,
    },
  })
}

export const FindPospalCoupon = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponPospal/${id}`,
  })
}

export const ResendPospalCouponCode = async ({
  shopId,
  id,
}) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponPospal/${id}/resendCouponCode`,
    data: {},
  })
}

/**
 * admin.couponPospal.findFailedRecords
 * 取得瑞乘優惠券失敗紀錄列表
 * @param {Object} params
 * @param {string} params.shopId
 * @param {string} [params.memberNameOrPhone]
 * @param {string} [params.pospalEcouponName]
 * @param {string} [params.pospalEcouponId]
 * @param {number} params.start
 * @param {number} params.limit
 */
export const GetPospalFailedRecords = async ({
  shopId,
  memberNameOrPhone,
  pospalEcouponName,
  pospalEcouponId,
  start,
  limit,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponPospal/failedRecords`,
    params: {
      memberNameOrPhone,
      pospalEcouponName,
      pospalEcouponId,
      start,
      limit,
    },
  })
}

/**
 * admin.couponPospal.countFailedRecords
 * 取得瑞乘優惠券失敗紀錄數量
 * @param {Object} params
 * @param {string} params.shopId
 * @param {string} [params.memberNameOrPhone]
 * @param {string} [params.pospalEcouponName]
 * @param {string} [params.pospalEcouponId]
 */
export const GetPospalFailedRecordsCount = async ({
  shopId,
  memberNameOrPhone,
  pospalEcouponName,
  pospalEcouponId,
}) => {
  return admin2({
    method: 'GET',
    url: `/${shopId}/couponPospal/failedRecords/count`,
    params: {
      memberNameOrPhone,
      pospalEcouponName,
      pospalEcouponId,
    },
  })
}

/**
 * admin.couponPospal.retryAllFailedIssuance
 * 重試所有瑞乘優惠券失敗發放
 * @param {Object} params
 * @param {string} params.shopId
 */
export const RetryAllPospalFailedIssuance = async ({ shopId }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/couponPospal/retryAllFailedIssuance`,
    data: {},
  })
}

// 手動同步pospal交易及相關資訊
export const ManualSyncPospalTransaction = async ({ shopId }) => {
  return admin2({
    method: 'POST',
    url: `/${shopId}/shopCustomModule/posPal/manualSyncPosPalTrxAndRelatedUpdates`,
  })
}
